import { z } from "zod";

const COMPANY_EMAIL_SUFFIXES = [
  "@caeliusconsulting.com",
  "@theivyclinics.com",
  "@sqelabs.com",
] as const;

export const COMPANY_EMAIL_ERROR =
  "Please use a company email address ending with @caeliusconsulting.com, @theivyclinics.com or @sqelabs.com";

export function isCompanyEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  return COMPANY_EMAIL_SUFFIXES.some((suffix) => normalized.endsWith(suffix));
}

export const itApprovalFormSchema = z.object({
  ccEmail: z
    .string()
    .min(1, "Email is required")
    .email("Invalid email address")
    .refine(isCompanyEmail, { message: COMPANY_EMAIL_ERROR }),
});

export type ItApprovalFormValues = z.infer<typeof itApprovalFormSchema>;
